import {AppOpenedRedirectInterface} from '@/src/ports/services/app-open-redirect'
import {MappedRedirectInterface} from '@/src/ports/services/mapped-redirect'
import {settings} from '@/src/config/settings'

export class AppOpenedRedirect implements AppOpenedRedirectInterface {
  redirectService: MappedRedirectInterface

  constructor(redirectService: MappedRedirectInterface) {
    this.redirectService = redirectService
  }

  cleanOrigin(path: string) {
    return path.replace(/[^/]+\/\/[^/]+(\/.*)/gim, '$1')
  }

  do(pathname: string): string | undefined {
    if (decodeURI(location.search).search('redirected=1') >= 0) {
      return
    }

    const pathnameNormalized = this.cleanOrigin(pathname)

    let redirectUrl = this.redirectService.do(pathnameNormalized)

    if (!redirectUrl) return

    if (redirectUrl === pathnameNormalized) return

    const url = new URL(location.origin + redirectUrl)
    url.searchParams.set('redirected', '1')

    redirectUrl = this.cleanOrigin(url.toString())

    if (process.env.NODE_ENV === 'development' || settings.NEXT_PUBLIC_APP_ENV == 'development') {
      // alert('Navigating: ' + redirectUrl)
    }

    return redirectUrl
  }
}
